/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 22/03/2024
 */

import auth from '../../../middleware/auth.js';
import shortcuts from '../../../middleware/shortcuts.js';
import {appHelper} from "../../../utils/helpers/appHelper.js";
import {routeHelper} from "../../../utils/helpers/routeHelper.js";
export const TmsRegions = [
    {
        path: appHelper.path.tmsApp + '/region/currency',
        name: 'tmsAppCurrency',
        component: routeHelper.asyncComponentWithLoader(() => import('../../region/views/currency/index.vue'))
    },
    {
        path: appHelper.path.tmsApp + '/region/country',
        name: 'tmsAppCountry',
        component: routeHelper.asyncComponentWithLoader(() => import('../../region/views/country/index.vue')),
        meta: { showPageTitle: true, middleware: [auth, shortcuts] }
    },
    {
        path: appHelper.path.tmsApp + '/region/state',
        name: 'tmsAppState',
        component: routeHelper.asyncComponentWithLoader(() => import('../../region/views/state/index.vue')),
        meta: { showPageTitle: true, middleware: [auth, shortcuts] }
    },
    {
        path: appHelper.path.tmsApp + '/region/city',
        name: 'tmsAppCity',
        component: routeHelper.asyncComponentWithLoader(() => import('../../region/views/city/index.vue')),
        meta: { showPageTitle: true, middleware: [auth, shortcuts] }
    }
];
